<template>
  <DModal :show-close="false" :isBgOverlay="true" :placeInTop="true" @close="$emit('close')">
    <div class="d-modal" id="d-create-task-for-user" slot="insertComponent">
      <div class="d-modal__header">
        <h2>{{ editEvent ? 'Rediger' : 'Opret' }} vagt til {{ user.name }}</h2>
      </div>
      <div class="d-modal__content">
        <!--
        <Tabslist :tabs="tabs" class="marg-1-bottom" :selected="activeTab" @select="selectTab"></Tabslist>
        -->
        <div class="d-group">
          <div class="time-changer__group">
            <TimeChanger
              :showIcon="true"
              :start="startTime"
              :end="endTime"
              :isFiveMinutesInterval="false"
              @updateStart="setStartTime"
              @updateEnd="setEndTime">
            </TimeChanger>
          </div>
        </div>
        <div class="d-group">
          <DateSelector
            :date="date"
            @changed="setDate">
          </DateSelector>
        </div>
      </div>
      <div class="do-modal__footer" :class="{'do-modal__footer--flex': editEvent}">
        <button class="do-bttn" @click="onDelete" v-if="editEvent"><span class="icon-bin"></span></button>
        <div class="do-modal__footer__right">
          <button class="do-bttn" @click="$emit('close')">{{ $t('vue2.common.cancel') }}</button>
          <button class="do-bttn do-bttn--submit"
                  v-if="editEvent"
                  :class="{'do-bttn--submit--loading': isSubmitting}"
                  @click="onSubmitEditEvent">{{ $t('vue2.common.update') }}
          </button>
          <template v-else>
            <button class="do-bttn do-bttn--submit do-bttn--submit--disabled" v-if="!isValidated">{{
                $t('vue2.common.save')
              }}
            </button>
            <button class="do-bttn do-bttn--submit" v-else
                    :class="{'do-bttn--submit--loading': isSubmitting}"
                    @click="submit">{{ $t('vue2.common.save') }}
            </button>
          </template>
        </div>
      </div>
    </div>
  </DModal>
</template>

<script>
import docendo from '../../../docendo'
import DModal from '../../common/DModal'
import dSelect from '../../DSelect/DSelect.vue'
import moment from 'moment'
import TimeChanger from '../../TimeChanger'
import eventbus from '../../../eventbus'
import DateSelector from '../../datepicker/DateSelector.vue'
import Tabs from '../../common/Tabs.vue'

export default {
  components: {Tabs, dSelect, DModal, TimeChanger, DateSelector},
  props: {
    user: {
      type: Object,
      default: () => {
        return {
          name: 'Henrik',
          user_calendar_id: 7
        }
      }
    },
    date: {
      type: Object,
      default: () => moment()
    },
    initSubject: {
      type: Object,
      default: null
    },
    theNewlyCreatedSubject: {
      type: Object,
      default: null
    },
    editEvent: {
      type: Object,
      default: null
    },
    openingHours: {
      default: null
    }
  },
  data () {
    return {
      isLoadingSubject: false,
      subjects: [],
      startTime: moment().set({'hour': 8, 'minutes': 0}),
      endTime: moment().set({'hour': 16, 'minutes': 0}),
      selectedSubject: null,
      isSubmitting: false,
      theSearchText: '',
      theNewSubject: null,
      isShowCreateSubjectButton: false,
      tabs: ['Med børn', 'Uden Børn', 'Fravær'],
      activeTab: 'Med børn'
    }
  },
  computed: {
    isWithKids () {
      return this.activeTab === 'Med børn'
    },
    isValidated () {
      return this.selectedSubject
    },
    filteredSubjects () {
      return this.subjects.filter(subject => subject.subject_type !== 'absence')
    },
    sortedSubjects () {
      return this.filteredSubjects
        .map(subject => {
          // Try to get the translation for 'subject_type'
          const translatedSubjectType = this.$t(`vue2.eventTypes.${subject.subject_type}`)

          // Check if the translation was found or if it returned the same key
          const vSubjectType = translatedSubjectType === `vue2.eventTypes.${subject.subject_type}`
            ? subject.subject_type
            : translatedSubjectType
          // Return the subject with the new property 'v_subject_type'
          return {
            ...subject,
            vSubjectType
          }
        })
        .sort((a, b) => {
          // Sort alphabetically by the 'name' property
          if (a.name < b.name) return -1
          if (a.name > b.name) return 1
          return 0
        })
    },
    dbEventStart () {
      let date = moment(this.date).format('YYYY-MM-DD')
      let time = this.startTime.locale('LT')
      return moment(date).set({
        hour: time.get('hour'),
        minutes: time.get('minutes')
      })
    },
    dbEventEnd () {
      let date = moment(this.date).format('YYYY-MM-DD')
      let time = this.endTime.locale('LT')
      return moment(date).set({
        hour: time.get('hour'),
        minutes: time.get('minutes')
      })
    }
  },
  watch: {
    theNewlyCreatedSubject (val) {
      this.readSubjects()
    }
  },
  methods: {
    selectTab (tab) {
      this.activeTab = tab
    },
    setDate (date) {
      this.$emit('setDate', date)
    },
    onCloseDSelect () {
      this.isShowCreateSubjectButton = false
    },
    setIsShowCreateSubjectButton () {
      const idx = this.filteredSubjects.findIndex(subject => subject.name === this.theSearchText)
      this.isShowCreateSubjectButton = this.theSearchText.length > 0 && idx < 0
    },
    onSearchTextDebounced () {
      this.setIsShowCreateSubjectButton()
    },
    onCreateNewSubject () {
      this.$emit('createNewSubject', this.theSearchText)
      this.theSearchText = ''
    },
    setTheSearchText (str) {
      this.theSearchText = str
    },
    setSubject (arr) {
      this.selectedSubject = arr[0]
    },
    setStartTime (payload) {
      this.startTime = payload
    },
    setEndTime (payload) {
      this.endTime = payload
    },
    readSubjects () {
      this.isLoadingSubject = true
      docendo.sidebar(this.user.user_calendar_id, this.date, success => {
        this.isLoadingSubject = false
        this.subjects = success
        this.$nextTick(_ => {
          if (this.theNewlyCreatedSubject) {
            this.theNewSubject = this.theNewlyCreatedSubject
          }
        })
      }, failure => {
        console.log('something went wrong')
      })
    },
    onDelete () {
      this.$emit('deleteEvent', this.editEvent)
    },
    onSubmitEditEvent () {
      this.isSubmitting = true
      const schoolId = this.editEvent.school_id
      const updates = [{event_id: this.editEvent.event_id, start_time: this.dbEventStart, end_time: this.dbEventEnd}]
      docendo.updateEvents(schoolId, updates, data => {
        if (data && data.status === 'error') {
          eventbus.toast = {text: data.message, 'success': false}
          this.$emit('close')
          return
        }
        this.isSubmitting = false
        const deletedEventId = data.id
        // const lesson = JSON.parse(data)
        this.$emit('updatedEvent', deletedEventId)
        eventbus.toast = {text: this.$t('vue2.create_activity.created'), 'success': true}
      }, failure => {
        eventbus.toast = {text: 'Something went wrong', 'success': false}
      })
    },
    submit () {
      const schoolId = this.selectedSubject.school_id
      const calendarId = this.selectedSubject.calendar_id
      const calendarIds = [calendarId, ...this.selectedSubject.cals.map(calendar => calendar.id)]
      const subjectId = this.selectedSubject.id
      const internalNote = ''
      this.isSubmitting = true
      docendo.createEvent(schoolId, calendarId, calendarIds, subjectId, this.dbEventStart, this.dbEventEnd, '', '', '', internalNote, data => {
        if (data && data.status === 'error') {
          eventbus.toast = {text: data.message, 'success': false}
          this.$emit('close')
          return
        }
        const lesson = JSON.parse(data)
        this.$emit('onCreatedEvent', lesson)
        this.$emit('close')
        eventbus.toast = {text: this.$t('vue2.create_activity.created'), 'success': true}
      }, failure => {
        eventbus.toast = {text: 'Something went wrong', 'success': false}
      })
    }
  },
  mounted () {
    setTimeout(_ => {
      const el = document.querySelector('.time-changer__group > .flex.align-center > div:first-child > .d-time-change-input')
      if (el) {
        el.select()
      }
    }, 0)
    if (!this.editEvent && this.openingHours) {
      const openingHoursObj = this.openingHours
      const dateDayNum = moment(this.date).isoWeekday()
      const data = openingHoursObj[dateDayNum]
      if (data) {
        const openHoursAndMinute = data['open'] // 13:12
        const [hour, minute] = openHoursAndMinute.split(':') // Split into "13" and "12"
        if (openHoursAndMinute) {
          this.startTime = moment().set({'hour': hour, 'minutes': minute})
        }
        const closeHoursAndMinute = data['close'] // 13:12
        const [closeHour, closeMinute] = closeHoursAndMinute.split(':') // Split into "13" and "12"
        if (closeHoursAndMinute) {
          this.endTime = moment().set({'hour': closeHour, 'minutes': closeMinute})
        }
      }
    }
    if (this.editEvent) {
      const startHour = moment(this.editEvent.start).format('HH')
      const startMinute = moment(this.editEvent.start).format('mm')
      this.startTime = moment().set({'hour': startHour, 'minutes': startMinute})
      const endHour = moment(this.editEvent.end).format('HH')
      const endMinute = moment(this.editEvent.end).format('mm')
      this.endTime = moment().set({'hour': endHour, 'minutes': endMinute})
      return
    }
    if (this.initSubject) {
      this.selectedSubject = this.initSubject
    }
    this.readSubjects()
  }
}
</script>

<style scoped>
@import "../../../assets/css/variables.css";

.d-modal {
  width: 550px;
  border-radius: 16px;
  position: relative;
}

.d-modal__header {
  margin-bottom: 0;
}

.d-modal__close {
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 16px !important;
}

.d-modal__buttons {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.d-modal__content {
  padding: 2rem 3rem;
}

.d-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.choose-subject {
  position: relative;
}

.create-new-subject {
  position: absolute;
  top: 0.2rem;
  right: -2.6rem;
}

.d-icon-plus {
  font-size: 13px;
}

.d-icon-plus:before {
  content: '+';
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 14px;
  height: 14px;
  background-color: rgb(162, 163, 166);
  opacity: 0.6;
}

.create-subject-link {
  background-color: var(--blue) !important;
  color: white;
  cursor: pointer;
}

.choose-subject__event_type {
  padding: 0 0.55rem;
  font-style: italic;
  font-size: 10px;
  color: #afafb3;
  border-color: #999;
}

.do-modal__footer.do-modal__footer--flex {
  justify-content: space-between;
}

.do-modal__footer__right {
  display: flex;
  gap: 1rem;
}
</style>



// WEBPACK FOOTER //
// CreateEventForm.vue?12574531